export const WHITE = 0
export const BLACK = 1

export type Color = typeof WHITE | typeof BLACK

export const COLORS = [WHITE, BLACK] as const

/** Colours are 0 and 1 precisely so this is a xor. */
export const opposite = (color: Color): Color => (color ^ 1) as Color

export const colorName = (color: Color): 'white' | 'black' => (color === WHITE ? 'white' : 'black')

export const colorFromName = (name: 'white' | 'black'): Color => (name === 'white' ? WHITE : BLACK)
